export function detectMimeType(b64: string) {
  const signatures: any = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    "/9j/": "image/jpg",
  };
  for (const s in signatures) {
    if (b64.indexOf(s) === 0) {
      return signatures[s];
    }
  }
}

export function getImageString(b64: string) {
  if (b64) return "data:" + detectMimeType(b64) + ";base64," + b64;
  else return "";
}

export function base64toExcel(respData: string, fileName: string) {
  const decodedPdfContent = window.atob(respData);
  const byteArray = new Uint8Array(decodedPdfContent.length);
  for (let i = 0; i < decodedPdfContent.length; i++) {
    byteArray[i] = decodedPdfContent.charCodeAt(i);
  }
  const blob = new Blob([byteArray.buffer], { type: "application/vnd.ms-excel" });
  const _pdfurl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  document.body.appendChild(link);
  link.href = _pdfurl;
  link.download = fileName;
  const evt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: false,
  });
  link.dispatchEvent(evt);
  window.URL.revokeObjectURL(_pdfurl);
  link.remove();
}

export function base64toZip(respData: string, fileName: string) {
  const decodedPdfContentzip = window.atob(respData);
  const byteArrayzip = new Uint8Array(decodedPdfContentzip.length);
  for (let i = 0; i < decodedPdfContentzip.length; i++) {
    byteArrayzip[i] = decodedPdfContentzip.charCodeAt(i);
  }
  const blobzip = new Blob([byteArrayzip.buffer], { type: "application/zip" });
  const _pdfurlzip = URL.createObjectURL(blobzip);
  const linkzip = document.createElement("a");
  document.body.appendChild(linkzip);
  linkzip.href = _pdfurlzip;
  linkzip.download = fileName;
  const evtzip = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: false,
  });
  linkzip.dispatchEvent(evtzip);
  window.URL.revokeObjectURL(_pdfurlzip);
  linkzip.remove();
}

export function base64toPDF(respData: string, fileName: string) {
  const decodedPdfContents = window.atob(respData);
  const byteArrays = new Uint8Array(decodedPdfContents.length);
  for (let i = 0; i < decodedPdfContents.length; i++) {
    byteArrays[i] = decodedPdfContents.charCodeAt(i);
  }
  const blobs = new Blob([byteArrays.buffer], { type: "application/pdf" });
  const _pdfurls = URL.createObjectURL(blobs);
  const links = document.createElement("a");
  document.body.appendChild(links);
  links.href = _pdfurls;
  links.download = fileName;
  const evts = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: false,
  });
  links.dispatchEvent(evts);
  window.URL.revokeObjectURL(_pdfurls);
  links.remove();
}

export const openBase64PDFInNewTab = (base64Data: string, fileName: string) => {
  const sliceSize = 1024;
  const byteCharacters = window.atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);
  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);
    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset)
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  const blob = new Blob(byteArrays, { type: "application/pdf" });
  const nav = window.navigator as any;
  if (nav && nav.msSaveOrOpenBlob)
    nav.msSaveOrOpenBlov(blob, `${fileName}.pdf`);
  else window.open(URL.createObjectURL(blob));
};

export const getImageBase64String = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result as string);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
export const downloadBase64Image = (b64String: string, fileName: string) => {
  if (b64String) {
    const downloadLink = document.createElement("a");
    downloadLink.href = b64String;
    downloadLink.download = fileName;
    downloadLink.click();
  }
};

export const getImageFileExtension = (base64String: string) => {
  switch (base64String) {
    case "image/gif":
      return ".gif";
    case "image/png":
      return ".png";
    case "image/jpg":
      return ".jpg";
  }
};
